<template>
  <div>
    <fidelior-title text="Search" />
    <div class="alert alert-light border" role="alert">
      The journal search tool provides basic functionality to available lists. The search bar allows a user to search according to the journal title, ISSN number or publisher.
      <strong
        style="color: orange !important"
      >Orange lists</strong> indicate possibly questionable journals, as per available lists in the public domain, while
      <strong
        style="color: green !important"
      >green lists</strong> indicate reputable journals. A search will return a list of journals matching search criteria.
    </div>
    <b-form @submit="search">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-6">
            <b-form-group
              id="input-group-search-term"
              label="Search term"
              label-for="input-search-term"
            >
              <b-form-input id="input-search-term" v-model="form.term"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-sm-6 form-group d-flex">
            <b-button variant="danger" type="submit" :disabled="form.working" class="mt-auto ">
              <font-awesome-icon icon="circle-notch" class="fa-spin" v-if="form.working" />Search
            </b-button>
          </div>
        </div>
      </div>
    </b-form>
    <ag-grid-vue
      domLayout="autoHeight"
      class="ag-theme-balham"
      :columnDefs="columns"
      :rowData="rows"
    ></ag-grid-vue>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        working: false,
        term: ""
      },
      columns: null,
      rows: null
    };
  },
  methods: {
    search(evt) {
      evt.preventDefault();
    }
  },
  beforeMount() {
    this.columns = [
      { headerName: "Title", field: "title", sortable: true, filter: true },
      {
        headerName: "Print ISSN",
        field: "printIssn",
        sortable: true,
        filter: true
      },
      {
        headerName: "Online ISSN",
        field: "onlineIssn",
        sortable: true,
        filter: true
      },
      {
        headerName: "List Names",
        field: "listNames",
        sortable: true,
        filter: true
      },
      {
        headerName: "Inclusion Date",
        field: "inclusionDate",
        sortable: true,
        filter: true
      },
      {
        headerName: "Status / Reason",
        field: "status",
        sortable: true,
        filter: true
      },
      {
        headerName: "Journal Website",
        field: "journalWebsite",
        sortable: true,
        filter: true
      },
      {
        headerName: "Publisher",
        field: "publisher",
        sortable: true,
        filter: true
      },
      {
        headerName: "Categories",
        field: "categories",
        sortable: true,
        filter: true
      }
    ];

    this.rows = [];
  }
};
</script>